import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "request-shell" }
const _hoisted_2 = { class: "card-section" }
const _hoisted_3 = { class: "grid request-grid" }
const _hoisted_4 = { class: "input-field" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "input-field" }
const _hoisted_7 = { class: "input-field" }
const _hoisted_8 = { class: "card-section" }
const _hoisted_9 = { class: "section-header" }
const _hoisted_10 = {
  key: 0,
  class: "hint"
}
const _hoisted_11 = {
  key: 1,
  class: "list"
}
const _hoisted_12 = { class: "item-meta" }
const _hoisted_13 = { class: "item-meta" }
const _hoisted_14 = { class: "item-meta" }
const _hoisted_15 = { class: "actions" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _cache[10] || (_cache[10] = _createElementVNode("h2", { class: "section-title" }, "Solicitar item do almoxarife", -1)),
      _createElementVNode("form", {
        class: "form-grid",
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.createRequest && _ctx.createRequest(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[6] || (_cache[6] = _createElementVNode("label", { for: "req-item" }, "Item", -1)),
            _withDirectives(_createElementVNode("select", {
              id: "req-item",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.itemId) = $event))
            }, [
              _cache[5] || (_cache[5] = _createElementVNode("option", { value: "" }, "Selecione", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: item.id,
                  value: item.id
                }, _toDisplayString(item.name) + " (disp: " + _toDisplayString(item.availableQuantity) + ") ", 9, _hoisted_5))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.form.itemId]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[7] || (_cache[7] = _createElementVNode("label", { for: "req-qty" }, "Quantidade", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "req-qty",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.quantity) = $event)),
              type: "number",
              min: "1"
            }, null, 512), [
              [
                _vModelText,
                _ctx.form.quantity,
                void 0,
                { number: true }
              ]
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[8] || (_cache[8] = _createElementVNode("label", { for: "req-notes" }, "Observacao", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "req-notes",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.notes) = $event)),
              type: "text",
              placeholder: "Opcional"
            }, null, 512), [
              [_vModelText, _ctx.form.notes]
            ])
          ])
        ]),
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "actions" }, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            type: "submit"
          }, "Solicitar item")
        ], -1))
      ], 32)
    ]),
    _createElementVNode("section", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _cache[11] || (_cache[11] = _createElementVNode("h2", { class: "section-title" }, "Itens que estao sobre sua custodia", -1)),
        _createElementVNode("button", {
          class: "btn btn-ghost",
          type: "button",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleReturned && _ctx.toggleReturned(...args)))
        }, _toDisplayString(_ctx.showReturned ? 'Ocultar ferramentas devolvidas' : 'Consultar ferramentas ja devolvidas'), 1)
      ]),
      (_ctx.requests.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, "Nenhum item para exibicao."))
        : (_openBlock(), _createElementBlock("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requests, (entry) => {
              return (_openBlock(), _createElementBlock("article", {
                key: entry.id,
                class: "item-card request-card"
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.itemLabel(entry.itemId)), 1),
                  _createElementVNode("div", _hoisted_12, "Quantidade: " + _toDisplayString(entry.quantity), 1),
                  _createElementVNode("div", _hoisted_13, "Status: " + _toDisplayString(_ctx.statusLabel(entry.status)), 1),
                  _createElementVNode("div", _hoisted_14, "Atualizado em: " + _toDisplayString(entry.updatedAt || entry.createdAt), 1)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  (entry.status === 2)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-primary",
                        type: "button",
                        onClick: ($event: any) => (_ctx.confirmProvided(entry.id, true))
                      }, " Foi fornecido ", 8, _hoisted_16))
                    : _createCommentVNode("", true),
                  (entry.status === 2)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "btn btn-ghost",
                        type: "button",
                        onClick: ($event: any) => (_ctx.confirmProvided(entry.id, false))
                      }, " Nao fornecido ", 8, _hoisted_17))
                    : _createCommentVNode("", true),
                  (entry.status === 3)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        class: "btn btn-ghost",
                        type: "button",
                        onClick: ($event: any) => (_ctx.requestReturn(entry.id))
                      }, " Solicitar devolucao ", 8, _hoisted_18))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ]))
    ])
  ]))
}